import { render } from "./AgreementInfo.vue?vue&type=template&id=472fde5a&scoped=true"
import script from "./AgreementInfo.vue?vue&type=script&lang=js"
export * from "./AgreementInfo.vue?vue&type=script&lang=js"

import "./AgreementInfo.vue?vue&type=style&index=0&id=472fde5a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472fde5a"]])

export default __exports__